/* Custom flise - Options popup */

// KONFIGURATION: Sæt til false hvis popups IKKE skal lukkes automatisk ved variant valg
const AUTO_CLOSE_POPUP_ON_SELECT = true;

// Funktion til at åbne og lukke popups
function setupPopupTriggers() {
  document.querySelectorAll('[data-open]').forEach(trigger => {
    const target = document.querySelector(`.${trigger.dataset.open}`)
    if (!target) return

    trigger.addEventListener('click', e => {
      e.preventDefault()
      target.classList.toggle('popup-open')
    })

    setupPopupClose(target)
  })
}

// Funktion til at setup popup lukning
function setupPopupClose(target) {
  // Klik på popup background lukker
  target.addEventListener('click', () => {
    target.classList.remove('popup-open')
  })

  // Klik inde i popup skal ikke lukke
  const inner = target.querySelector('.popup-inner')
  if (inner) {
    inner.addEventListener('click', e => {
      e.stopPropagation()
    })
  }

  // Klik på close button lukker popup
  const closeButton = target.querySelector('.popup-close-button')
  if (closeButton) {
    closeButton.addEventListener('click', e => {
      e.stopPropagation()
      target.classList.remove('popup-open')
    })
  }
}

// Setup alle popup triggers
setupPopupTriggers()

// Setup delivery confirmation popup
const deliveryPopup = document.querySelector('.popup-delivery-confirm')
if (deliveryPopup) {
  setupPopupClose(deliveryPopup)
  
  // Open delivery confirmation popup når man klikker på add-to-cart med data-open-delivery-confirm
  const addToCartButton = document.querySelector('[data-open-delivery-confirm]')
  if (addToCartButton) {
    addToCartButton.addEventListener('click', e => {
      e.preventDefault()
      
      // Tjek om knappen er disabled
      if (addToCartButton.disabled) {
        return
      }
      
      // Åbn delivery confirmation popup
      deliveryPopup.classList.add('popup-open')
    })
  }
  
  // Cancel button lukker popup
  const cancelButton = deliveryPopup.querySelector('[data-cancel-delivery-confirm]')
  if (cancelButton) {
    cancelButton.addEventListener('click', () => {
      deliveryPopup.classList.remove('popup-open')
    })
  }
  
  // Accept button fortsætter til add to cart
  const confirmButton = deliveryPopup.querySelector('[data-confirm-delivery-proceed]')
  if (confirmButton) {
    confirmButton.addEventListener('click', () => {
      // Luk popup
      deliveryPopup.classList.remove('popup-open')
      
      // Trigger den originale add-to-cart funktionalitet
      const addToCartEvent = new CustomEvent('proceed-add-to-cart')
      document.dispatchEvent(addToCartEvent)
    })
  }
}

// Hent alle varianter fra variant-picker scriptet
function getAllVariants() {
  const variantScript = document.querySelector('variant-picker script[type="application/json"]');
  if (variantScript) {
    const data = JSON.parse(variantScript.textContent);
    return data.variants || [];
  }
  return [];
}

// Find variant baseret på option1 og option2
function findVariantByOptions(option1, option2) {
  const variants = getAllVariants();
  return variants.find(v => v.option1 === option1 && v.option2 === option2);
}

// Opdater calculator dropdown fra variant-picker change
document.addEventListener('on:variant:change', function(event) {
  console.log('Variant changed:', event.detail);
  
  if (event.detail && event.detail.variant) {
    const variant = event.detail.variant;

    // Opdater URL med variant parameter
    if (variant.id) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      console.log('Updated URL with variant:', variant.id);
    }
    
    // Opdater farve dropdown
    const colorWrapper = document.querySelector('[data-open="popup-color-options"]');
    if (colorWrapper) {
      const label = colorWrapper.querySelector('.additional-product-label');
      const img = colorWrapper.querySelector('#selected-variant-image');
      
      if (label && variant.option1) {
        label.textContent = variant.option1;
        console.log('Updated color label to:', variant.option1);
      }
      
      if (img && variant.featured_image) {
        img.src = variant.featured_image.src;
        console.log('Updated image to:', variant.featured_image.src);
      }
    }
    
    // Opdater format dropdown
    const formatWrapper = document.querySelector('[data-open="popup-format-options"]');
    if (formatWrapper) {
      const label = formatWrapper.querySelector('.additional-product-label');
      const img = formatWrapper.querySelector('#selected-format-image');

      if (label && variant.option2) {
        label.textContent = variant.option2;
        console.log('Updated format label to:', variant.option2);
      }

      // Opdater format billede fra metafields
      if (img && typeof formatMetafields !== 'undefined' && formatMetafields[variant.id]) {
        const formatImage = formatMetafields[variant.id].formatImage;
        if (formatImage) {
          img.src = formatImage;
          console.log('Updated format image to:', formatImage);
        }
      }
    }

    // Opdater product title
    const titleName = document.querySelector('.product-title .title-name');
    const titleDesc = document.querySelector('.product-title .title-desc');

    if (titleName && variant.option2) {
      const base = titleName.getAttribute('data-base');
      titleName.textContent = base + ' ' + variant.option2;
    }

    if (titleDesc && variant.option1) {
      titleDesc.textContent = variant.option1;
    }

    // Opdater hovedbillede (featured image)
    updateFeaturedImage(variant);

  }
});

function updateFeaturedImage(variant) {
  if (!variant.featured_image) return;

  const newImageUrl = variant.featured_image.src;
  const baseSrc = newImageUrl.split('?')[0];
  const basename = baseSrc.split('/').pop();

  // Opdater img
  const mainImageContainer = document.querySelector('.product-media-collage__item');
  if (!mainImageContainer) return;

  const imgElement = mainImageContainer.querySelector('img');
  if (!imgElement) return;

  const widths = [400, 600, 800, 1000, 1200];
  const srcset = widths.map(w => `${baseSrc}?width=${w} ${w}w`).join(', ');
  imgElement.src = `${baseSrc}?width=1200`;
  imgElement.srcset = srcset;
  imgElement.alt = variant.name || imgElement.alt;

  // Find korrekt media-id fra template ved at matche filnavn
  const template = document.querySelector('.js-media-zoom-template');
  if (template) {
    const thumbs = template.content.querySelectorAll('.gallery-viewer__thumb');
    const matchingThumb = Array.from(thumbs).find(thumb => {
      return (thumb.dataset.zoomUrl || '').includes(basename);
    });

    if (matchingThumb) {
      const mediaId = matchingThumb.dataset.mediaId;
      const correctZoomUrl = matchingThumb.dataset.zoomUrl; // Brug URL direkte fra template
      
      // Opdater collage item data-media-id
      mainImageContainer.dataset.mediaId = mediaId;
      
      // Opdater zoom link href med korrekt URL fra template
      const zoomLink = mainImageContainer.querySelector('a.show-gallery');
      if (zoomLink) {
        zoomLink.href = correctZoomUrl;
      }

      console.log('--------------------------------------');
      console.log('updateFeaturedImage: matched basename:', basename);
      console.log('updateFeaturedImage: mediaId from template:', mediaId);
      console.log('updateFeaturedImage: zoomUrl from template:', correctZoomUrl);
    }
  }
}

// Håndter popup valg
document.addEventListener('DOMContentLoaded', function() {
  const colorPopup = document.querySelector('.popup-color-options');
  const formatPopup = document.querySelector('.popup-format-options');
  
  if (colorPopup) {
    colorPopup.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', function() {
        console.log('Color radio changed to:', this.value);
        
        const selectedColor = this.value;
        const currentFormat = document.querySelector('[data-open="popup-format-options"] .additional-product-label')?.textContent.trim();
        
        console.log('Current format:', currentFormat);
        
        // Find den variant vi skal skifte til
        const targetVariant = findVariantByOptions(selectedColor, currentFormat);
        console.log('Target variant:', targetVariant);
        
        if (!targetVariant) {
          console.error('Could not find variant for:', selectedColor, currentFormat);
          return;
        }
        
        // Find og klik på farve option i variant-picker
        const variantPicker = document.querySelector('variant-picker');
        const colorSelect = variantPicker?.querySelector('custom-select[id*="farve"]');
        
        if (colorSelect) {
          const colorOption = Array.from(colorSelect.querySelectorAll('.custom-select__option'))
            .find(opt => opt.dataset.value === selectedColor);
          
          console.log('Found color option:', colorOption);
          
          if (colorOption) {
            colorOption.click();
            console.log('Clicked color option:', selectedColor);
            
            // Trigger variant change manuelt
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('on:variant:change', {
                detail: { variant: targetVariant }
              }));
            }, 100);
          }
        }
        
        // Luk popup kun hvis AUTO_CLOSE_POPUP_ON_SELECT er true
        if (AUTO_CLOSE_POPUP_ON_SELECT) {
          colorPopup.classList.remove('popup-open');
        }
      });
    });
  }
  
  if (formatPopup) {
    formatPopup.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', function() {
        console.log('Format radio changed to:', this.value);
        
        const selectedFormat = this.value;
        const currentColor = document.querySelector('[data-open="popup-color-options"] .additional-product-label')?.textContent.trim();
        
        console.log('Current color:', currentColor);
        
        // Find den variant vi skal skifte til
        const targetVariant = findVariantByOptions(currentColor, selectedFormat);
        console.log('Target variant:', targetVariant);
        
        if (!targetVariant) {
          console.error('Could not find variant for:', currentColor, selectedFormat);
          return;
        }
        
        // Find og klik på format option i variant-picker
        const variantPicker = document.querySelector('variant-picker');
        const formatSelect = variantPicker?.querySelector('custom-select[id*="format"]');
        
        if (formatSelect) {
          const formatOption = Array.from(formatSelect.querySelectorAll('.custom-select__option'))
            .find(opt => opt.dataset.value === selectedFormat);
          
          console.log('Found format option:', formatOption);
          
          if (formatOption) {
            formatOption.click();
            console.log('Clicked format option:', selectedFormat);
            
            // Trigger variant change manuelt
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('on:variant:change', {
                detail: { variant: targetVariant }
              }));
            }, 100);
          }
        }
        
        // Luk popup kun hvis AUTO_CLOSE_POPUP_ON_SELECT er true
        if (AUTO_CLOSE_POPUP_ON_SELECT) {
          formatPopup.classList.remove('popup-open');
        }
      });
    });
  }
});